/* eslint-disable */
import { auth } from '@/plugins/auth/firebase.js'
import Cookie from 'js-cookie'
import JWTDecode from 'jwt-decode'
import axios from 'axios'
import * as vars from '@/vars.json'

const httpAxios = axios.create({
  params: {},
})

import Swal from 'sweetalert2'
export const parsers = {
    namespaced: true,
    state: {
        currentShop: null,
        isLoading: false,
    },
    mutations: {
        SET_CURRENT_SHOP (state, payload) {
            state.currentShop = payload
        },
        SET_LOADING (state, payload) {
            state.isLoading = payload
        },
    },

    actions: {
        setCurrentShop ({ commit, state, rootState }, payload) {
            const setCommit = 'SET_CURRENT_SHOP'
            commit(setCommit, payload)
        },
        async createProduct ({ commit, state, rootState }, payload) {
            let userId = '' 
            if(rootState.users.user.adminUid){
                userId = rootState.users.user.adminUid
            }else{
                userId = rootState.users.user.uid
            }
            // console.log(state.user, userId)
            const key = payload.id ? payload.id : firebase.database().ref().child(`users/${userId}/inventory`).push().key
            const itemData = {
                ...payload,
                id: key,
                created: firebase.database.ServerValue.TIMESTAMP,
            }
            const updates = {}
            updates[`users/${userId}/inventory/${key}`] = itemData
            await firebase.database().ref().update(updates).then(function () {
                // created!

            })
        },
        async  updateProduct ({ commit, state, rootState }, payload) {
            commit('SET_LOADING', true)

            let userId = '' 
            if(rootState.users.user.adminUid){
                userId = rootState.users.user.adminUid
            }else{
                userId = rootState.users.user.uid
            }
            const itemData = payload
            await firebase.database().ref(`users/${userId}/inventory/${itemData.id}`).update(itemData).then(function () {
                    // updated!

                },
            ).catch(function (err) {
                // console.log(err)
            })
        },
        async createCategory ({ commit, state, rootState }, payload) {
            let userId = '' 
            if(rootState.users.user.adminUid){
                userId = rootState.users.user.adminUid
            }else{
                userId = rootState.users.user.uid
            }
            // console.log(payload)
            const key = payload.id ? payload.id : firebase.database().ref().child(`users/${userId}/categories`).push().key
            const itemData = {
                ...payload,
                id: key,
                created: firebase.database.ServerValue.TIMESTAMP,
            }
            const updates = {}
            updates[`users/${userId}/categories/${key}`] = itemData
            await firebase.database().ref().update(updates).then(async function () {
                // created!
            })
        },
        async createBulk ({ commit, dispatch, rootState, state }, payload) {
            commit('SET_LOADING', true)
            let userId = '' 
            if(rootState.users.user.adminUid){
                userId = rootState.users.user.adminUid
            }else{
                userId = rootState.users.user.uid
            }
            const allCategories = rootState.categories.category_list
            const allProducts = rootState.products.product_list
            const localCategories = []
            const localProducts = []
            const idShop = state.currentShop.id
            let categoriesShop = []
            let errorList = ''

            // Obtener categorias de tienda
            await firebase.database().ref().child(`users/${userId}/shops/${idShop}/categories/`).once('value', function (data) {
                if (data.val()) {
                    categoriesShop = data.val()
                }
            })

            // console.log(categoriesShop)

            const counts = {
                category_creations: 0,
                product_creations: 0,
                product_updates: 0,
                errors: 0,
            }
            // verificar que no hayan duplicados
            // recorrer las filas
            await payload.forEach(function (el, index) {
                // buscar todas las categorias y guardarlas en una lista
                // buscar por nombre si existen estas categorias en la BD
                // si no existen crearla en bd
                if (!el.NOMBRE || !el.CATEGORIA || isNaN(el.UNIDADES) || isNaN(el.VENTA) || isNaN(el.COMPRA) || +el.UNIDADES < 0 || +el.VENTA < 0 || +el.COMPRA < 0) {
                    let currentError
                    if (isNaN(el.UNIDADES) || isNaN(el.VENTA) || isNaN(el.COMPRA) || +el.UNIDADES < 0 || +el.VENTA < 0 || +el.COMPRA < 0) {
                        currentError = `
                                <li style="list-style: none; border-bottom: 1px solid #777; padding-bottom: 2px;">
                                    <v-flex style="display: flex;  align-items:center;">
                                        <b style="min-width: 50px">Linea ${index + 1}</b>
                                        <span> Verifica que las unidades, precio de venta y compra sean números positivos</span>     
                                    </v-flex>                      
                                 </li>
                            `
                    } else {
                        currentError = `
                            <li style="list-style: none;  border-bottom: 1px solid #777; padding-bottom: 2px;">
                                    <v-flex style="display: flex; align-items:center;">
                                        <b style="min-width: 50px">Linea ${index + 1}</b>
                                        <span> ${!el.NOMBRE && !el.CATEGORIA ? 'Falta nombre y categoria' : !el.NOMBRE ? 'Falta nombre' : 'Falta categoria'} </span>
                                    </v-flex>                             
                              
                             </li>
                            `
                    }
                    errorList = errorList + currentError
                    counts.errors++
                } else {
                    const el_category = allCategories.find(function (category) {
                        return category.name.toUpperCase() === el.CATEGORIA.toUpperCase()
                    })

                    let model_category = {}
                    if (!el_category) {
                        const isInLocalCategories = localCategories.find(function (category) {
                            return category.name.toUpperCase() === el.CATEGORIA.toUpperCase()
                        })
                        if (isInLocalCategories) {
                            model_category = isInLocalCategories
                        } else {
                            model_category = {
                                id: firebase.database().ref().child(`users/${userId}/categories`).push().key,
                                name: el.CATEGORIA,
                                pictures: {
                                    imageInput1: '',
                                },
                            }
                            dispatch('createCategory', model_category)
                            counts.category_creations++
                            categoriesShop.push(model_category)
                            localCategories.push(model_category)
                        }
                    } else {
                        model_category = el_category
                    }

                    //- Insertar categorias en tienda
                    const shop_category = categoriesShop.find(function (category) {
                        if (category) {
                            return category.name.toUpperCase() === el.CATEGORIA.toUpperCase()
                        }
                    })

                    if (!shop_category) {
                        const shop_created_category = allCategories.find(function (category) {
                            return category.name.toUpperCase() === el.CATEGORIA.toUpperCase()
                        })
                        categoriesShop.push(shop_created_category)
                    }

                    //- update categories store
                    const updateShop = {}
                    updateShop[`users/${userId}/shops/${idShop}/categories/`] = categoriesShop

                    firebase.database().ref().update(updateShop).then(async function () {
                        // created!
                    })
                    // luego de crear categorias, comenzar a crear los productos
                    // verificar si el producto ya existe en la bd, 'POR NOMBRE'

                    const el_product = allProducts.find(function (product) {
                        return product.name.toUpperCase() === el.NOMBRE.toUpperCase()
                    })
                    let model_product = {}
                    // si no existe, generar nuevo ID
                    if (!el_product) {
                        const isInLocalProducts = localProducts.find(function (product) {
                            return product.name.toUpperCase() === el.NOMBRE.toUpperCase()
                        })

                        if (isInLocalProducts) {
                            model_product = isInLocalProducts
                            model_product.location[state.currentShop.id] = {
                                id: state.currentShop.id,
                                image: state.currentShop.pictures.imageInput1 || '',
                                name: state.currentShop.name,
                                price: el.VENTA || 0,
                                pricewithouttax: el.VENTA || 0,
                                stock: el.UNIDADES || 0,
                            }

                            dispatch('updateProduct', model_product)
                            counts.product_updates++
                            // console.log('producto actualizado: ', model_product)
                        } else {
                            model_product = {
                                id: firebase.database().ref().child(`users/${userId}/inventory`).push().key,
                                name: el.NOMBRE,
                                categories: [
                                    model_category,
                                ],

                                price: {
                                    buy: el.COMPRA || 0,
                                    sale: el.VENTA || 0,
                                    salewithouttax: el.VENTA || 0,
                                },
                                type: el.TIPO === 'producto' ? 'product' : el.TIPO === 'servicio' ? 'service' : 'product',
                                pictures: {
                                    imageInput1: el.IMAGEN ? el.IMAGEN : '',
                                },
                            }
                            model_product.location = {}
                            model_product.location[state.currentShop.id] = {
                                id: state.currentShop.id,
                                image: state.currentShop.pictures.imageInput1 || '',
                                name: state.currentShop.name,
                                price: el.VENTA || 0,
                                pricewithouttax: el.VENTA || 0,
                                stock: el.UNIDADES || 0,
                            }
                            dispatch('createProduct', model_product)
                            counts.product_creations++
                            // console.log('producto nuevo: ', model_product)
                            localProducts.push(model_product)
                        }
                    } else {
                        model_product = el_product
                        model_product.location[state.currentShop.id] = {
                            id: state.currentShop.id,
                            image: state.currentShop.pictures.imageInput1 || '',
                            name: state.currentShop.name,
                            price: el.VENTA || 0,
                            pricewithouttax: el.VENTA || 0,
                            stock: el.UNIDADES || 0,
                        }

                        dispatch('updateProduct', model_product)
                        counts.product_updates++
                        // console.log('producto actualizado: ', model_product)

                        // si ya existe, entonces traer el ID del que esta en la base de datos
                        // si el producto ya existe, solo actualizar el location
                    }
                    // POBLAR EL OBJETO DEL ITEM que se va  para la BD
                }
            })

            Swal.fire({
                position: 'top',
                icon: 'success',
                title: 'Inventario cargado!',
                html: `
                        <v-layout style="display:flex; justify-content: space-between">
                            <v-flex style="flex: 1;">
                                <level style="display:flex flex-direction: column;"><b>Categorias creadas: </b><h3> ${counts.category_creations}</h3></level>
                                <level style="display:flex flex-direction: column;" ><b>Productos creados: </b><h3> ${counts.product_creations}</h3></level>
                                <level style="display:flex flex-direction: column;"><b>Productos actualizados: </b><h3> ${counts.product_updates}</h3></level>
                                
                            </v-flex>
                            <v-flex style=" flex: 1; display:flex; flex-direction: column; align-items: center">   
                                <level style="display:flex flex-direction: column;"><b>Errores: </b><h3 style="color : red"> ${counts.errors}</h3></level>                  
                                <ul style=" text-align: left; padding: 5px;  font-size: 10px; width: 100%; border: 1px solid red; max-height: 200px; overflow: auto;"> ${errorList} </ul> 
                            </v-flex>
                            
                        </v-layout>
                    `,
                showConfirmButton: true,

            })
            commit('SET_LOADING', false)
        },
        async uploadBotsolShops ({ commit, dispatch, rootState, state }, payload) {
            return new Promise((resolve, reject) => {
                httpAxios.post(vars.url + '/uploadBotsolShops', { csv: payload.csv, mainCategorie: payload.mainCategorie }).then((response) => {
                  resolve(response.data)
                }).catch((error) => {
                  reject(error)
                })
              })
        },
    },
    getters: {

    },

}
